// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import Arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import Icon_toolip from '../../img/competitors/toolip.svg';
import Icon_add from '../../img/icons/24/add.svg';
import {Input} from '../../../../hola/pub/lib/input';
import {i_company_name} from './vs_toolip';
import cn from 'classnames';
import styles from './vs_toolip.module.less';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';

interface i_vs_hero_props {
    hero_title?: string;
    hero_title_tag?: string;
    hero_subtitle?: string;
    hero_logo?: string;
    company?: i_company_name;
    cta?: string;
    after_cta?: string;
}

export const Vs_hero = (props: i_vs_hero_props)=>{
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    return <div className={cn(styles.vs_hero_wrapper, theme.container)}>
      <div className={styles.logos_section}>
        <div className={styles.logo_container}>
          <Icon_toolip/>
        </div>
        {/* <span className={cn(theme.p22, theme.med)}>+</span> */}
        <Icon_add />
        <div className={styles.logo_container}>
          <img src={props.hero_logo}/>
        </div>
      </div>
      <div className={styles.text_section}>
        <Dynamic_heading tag={props.hero_title_tag}>{props.hero_title}
        </Dynamic_heading>
        <p className={cn(theme.mono18, theme.med, theme.color_n600)}>
          {props.hero_subtitle}
        </p>
      </div>
      <div className={styles.button_section}>
        <Button
          caption={<Fragment><T>{props.cta ||
            'Try Toolip for Free'}</T> <Arrow_right/>
            </Fragment>} round={false}
          size='lg' color='black' to='/dashboard' cls={styles.cta_button}
        />
        <p className={cn(theme.p12, theme.med)}>
          <T>{props.after_cta || 'Free proxies | No credit card required'}</T>
        </p>
      </div>
    </div>;
};

export const Vs_hero_editor = ({value, on_change})=>{
    return <div>
      <Input value={value.hero_title || ''}
        on_change={v=>on_change({...value, hero_title: v})}
        label={'Hero Title'} />
      <Title_header_select value={value.hero_title_tag} on_select={v=>
        on_change({...value, hero_title_tag: v})}/>
      <Input value={value.hero_subtitle || ''}
        on_change={v=>on_change({...value, hero_subtitle: v})}
        label={'Hero Subtitle'} />
      <Input value={value.hero_logo || ''}
        on_change={v=>on_change({...value, hero_logo: v})}
        label={'Company Logo URL'} />
      <Input value={value.cta || ''}
        on_change={v=>on_change({...value, cta: v})}
        label={'CTA Button Text'} />
      <Input value={value.after_cta || ''}
        on_change={v=>on_change({...value, after_cta: v})}
        label={'Text Under Button'} />
    </div>;
};
